<template>
    <iframe :src="url" frameborder="0" width="100%" :height="iframeHeight" @load="calc($event.target)"></iframe>
</template>

<script type="text/babel">

export default {
    name: 'download',
    data () {
        return {
            iframeHeight:'1605'
        }
    },
    computed:{
        url(){
            switch(this.$root.env){
                case 'qa': return 'https://www.pgyer.com/semqa';
                case 'uat': return 'https://www.pgyer.com/semUAT';
                default: return ''// todo: production url
            }
        }
    },
    methods: {
        calc(iframe){
            this.iframeHeight = iframe.contentWindow.document.documentElement.scrollHeight
        }
    },
    created(){
        this.$root.activeIndex = 'home'
        this.$root.headImage.src = ''
        this.$root.navs = []
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>




// WEBPACK FOOTER //
// src/pages/dsp/help/Download.vue